import React from 'react';

// Interface for error message component props
interface ErrorMessageProps {
    message: string;
}

export default function ErrorMessage({message}: ErrorMessageProps) {

  return (
      <>
          <div className="container">
              <div className="row mt-5">
                  <div className="col-md-5 m-auto">
                      <div className="card card-body">
                          <div>
                              <div className="alert alert-danger" role="alert">
                                {message}
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </>
    )
}